// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__14N59","colMin":"styles_colMin__1oLO-","colCheckbox":"styles_colCheckbox__2lO_L"};